import { HttpClient } from "../../../services/http/http-client";
import { MHTTPCL, JSON_STRING ,createHttpGetOptions} from "../../../services/http/http-client";
import { LABEL_URL, BELIEVE_CONTROLLER_URL, CONTACTS_URL, MODIFICATION_URL, DISTRIBUTION_URL } from "../../../services/common-urls";

const SUPPLIERORDERS = 'supplier_orders';

export const SupplierOrdersService = {

    distSuppliersTabSupplierOrdersList:()=>MHTTPCL.get(DISTRIBUTION_URL,{
      section:SUPPLIERORDERS,
      action:'dist_suppliers_tab_supplier_orders_list',
      output:JSON_STRING
    }),

    newSupplierOrderForm:()=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:'supplier_orders',
        action:'new_supplier_order_form',
        output:JSON_STRING
    }),

    addSupplierOrder:({supplier_id,supply_order_type})=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action:'add_supplier_order',
        supplier_id:supplier_id,
        supply_order_type:supply_order_type,
        output:JSON_STRING
	
    }),

    
    

    supplierOrders:(start)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	:"supplier_orders",
        start:start,
        output:JSON_STRING
    }),
    exportExcelSo:(supplier_order_id)=>MHTTPCL.postJSONasFormData(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	:"export_excel_so",
        supplier_order_id:supplier_order_id,
    } ,createHttpGetOptions({
        responseType: 'blob'
      })),
   

    filterSupplierOrders:({supplier_order_id='',supplier='',accounted_flag='',supply_order_type='',catalog_no=''})=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action :'filter_supplier_orders',
        supplier_order_id:supplier_order_id,
        supplier:supplier,
        accounted_flag:accounted_flag,    
        supply_order_type:supply_order_type,
        catalog_no:catalog_no,
        output:JSON_STRING
    }),

    removeSupplierOrder:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	: "remove_supplier_order",
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    supplierOrderDeleteConfirmationModalData:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section :	SUPPLIERORDERS,
        action	: "supplier_order_delete_confirmation_modal_data",
        supplier_order_id :supplier_order_id,
        output:JSON_STRING
    }),



    //FETCH SINGLE 

    supplierOrderDetails:(supplier_order_id)=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action:'supplier_order_details',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),
    supplierOrderDetailsTabOverview:(supplier_order_id)=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action:'supplier_order_details_tab_overview',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),
    supplierOrderDetailsTabBackorders:(supplier_order_id)=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action:'supplier_order_details_tab_backorders',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    getDeliveries:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"get_deliveries",
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),



    /// SOrderLines

    removeSupplierOrderline:(supplier_orderline_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	: "remove_supplier_orderline",
        supplier_orderline_id:supplier_orderline_id,
        output:JSON_STRING
    }),

    addSupplierOrderline:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	: "add_supplier_orderline",
        supplier_order_id:supplier_order_id,    
        order_qty:	"0",
        shortfall_qty:	"0",
        promo:	"0",
        output:JSON_STRING
    }),

    //setup
    searchProducts:(supplier_order_id,str="",product_type_id="")=>MHTTPCL.post(DISTRIBUTION_URL,{
        
        section	: SUPPLIERORDERS,
        action	:"search_products",
        supplier_order_id:supplier_order_id,
        str:str,
        product_type_id:product_type_id,
        output:JSON_STRING
    }),

    addSupplierOrderProduct:(supplier_order_id,product_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"add_supplier_order_product",
        supplier_order_id:supplier_order_id,
        product_id:product_id,
        output:JSON_STRING
    }),

    addSupplierOrderAccount:(supplier_order_id,account_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"add_supplier_order_account",
        supplier_order_id:supplier_order_id,
        account_id	:account_id,
        output:JSON_STRING

    }),

    
    searchAccounts:(supplier_order_id,str="")=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: "supplier_orders",
        action	: "search_accounts",
        supplier_order_id : supplier_order_id,
        str:str,
        output:JSON_STRING
    }),
    


    ///orderlines

    productTypes:()=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	:"product_types",
        output:JSON_STRING
    }),

    addMultipleProducts:(supplier_order_id,products)=>MHTTPCL.post(DISTRIBUTION_URL,{
      section	: SUPPLIERORDERS,
      action	: "add_multiple_products",
      supplier_order_id : supplier_order_id,
      products:JSON.stringify(products),
      output:JSON_STRING

    }),

    loadSupplierOrderlines:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action	:"load_supplier_orderlines",
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    removeAllLinesSo:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"remove_all_lines_so",
        supplier_order_id	:supplier_order_id,
        output:JSON_STRING
    }),
    importExcel: (formData) => {
        return MHTTPCL.postFormData(DISTRIBUTION_URL, formData);
    },



    searchMultipleProductsModalData:(supplier_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action	:"search_multiple_products_modal_data",
        supplier_id:supplier_id,
        output:JSON_STRING
    }),

    
    
    searchMultipleProducts:(supplier_order_id,str="",product_type_id,limit_to_supplier=1)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	:"search_multiple_products",
        supplier_order_id:supplier_order_id,
        str:str,
        product_type_id:product_type_id,
        limit_to_supplier:limit_to_supplier,
        output:JSON_STRING
    }),

    //buttons

    infoMailMultiProduct:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section: SUPPLIERORDERS ,
        action: 'info_mail_multi_product',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    shippingInfoMailSingle:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section: SUPPLIERORDERS ,
        action: 'shipping_info_mail_single',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING

    }),

    stockInInfoEmail:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section: SUPPLIERORDERS ,
        action: 'stock_in_info_email',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    lableTemplates:()=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"lable_templates",
        output:JSON_STRING
    }),

    poReceptionEmailData:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section: SUPPLIERORDERS,
        action: 'po_reception_email_data',
        supplier_order_id: supplier_order_id,
        output:JSON_STRING
    }),

    

    reopenOrderForm:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action:'reopen_order_form',
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    getLabelAccounts:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"get_label_accounts",
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    reopenOrderPost:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"reopen_order",
        supplier_order_id	:supplier_order_id,
        output:JSON_STRING
    }),

    reopenOrderGet:(supplier_order_id)=>MHTTPCL.get(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"reopen_order",
        supplier_order_id	:supplier_order_id,
        output:JSON_STRING
    }),

    finishOrder:({supplier_order_id,accounted_date,action})=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:action,
        supplier_order_id:supplier_order_id,
        accounted_date:accounted_date,
        output:JSON_STRING
    }),

    accountDelivery:({ supplier_order_id, shipping_date })=>MHTTPCL.get(DISTRIBUTION_URL,{
        section:SUPPLIERORDERS,
        action:'account_delivery',
        supplier_order_id:supplier_order_id,
        shipping_date:shipping_date,
        output:JSON_STRING
    }),

    accountDeliveryData:(data)=>MHTTPCL.post(DISTRIBUTION_URL,{
     section:SUPPLIERORDERS,
     action	:"account_delivery_data",
     data:JSON.stringify(data),
     output:JSON_STRING
    }),

    accountCostsMultiProduct:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	:"account_costs_multi_product",
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    accountCosts:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"account_costs",
        supplier_order_id:supplier_order_id,
        output:JSON_STRING
    }),

    confirmCostAmount:({supplier_order_id,order_value_single_product,exchangerate,txt_temp1,cost_group_id,external_ref})=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	: SUPPLIERORDERS,
        action	:"confirm_cost_amount",
        supplier_order_id:supplier_order_id,
        order_value_single_product	:order_value_single_product,
        exchangerate	:exchangerate,
        txt_temp1	:txt_temp1,
        cost_group_id	:cost_group_id,
        external_ref	:external_ref
    }),


    //backorder
    addSupplierOrderlineFromBo:(supplier_order_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SUPPLIERORDERS,
        action	:"add_supplier_orderline_from_bo",
        supplier_order_id	:supplier_order_id,
        output:JSON_STRING
    })




    


// section	"supplier_orders"
// action	"account_delivery_data"
// data:"{\"supplier_order_id\":\"185\",\"supplier_orderlines\":[{\"supplier_orderline_id\":\"390\",\"promo\":1,\"shipped_now\":100,\"reference_no\":\"100-D\",\"invoice\":1,\"ppu\":20,\"currency_id\":\"1\",\"exchange_rate\":\"1\",\"account_id\":\"279\",\"invoice_project_id\":\"206\",\"contact_id_invoice\":\"\",\"price_list_id\":\"\"}],\"sum_shipped\":100,\"shipping_date\":\"2022-07-25\"}"	





    

//     section	"supplier_orders"
// action	"account_order_multi_product"
// supplier_order_id	"189"
// accounted_date	"2022-07-01"

// section	"supplier_orders"
// action	"finish_order"
// accounted_date	"2022-07-25"
// supplier_order_id	"185"




    



    


    


    

    

    
    


    
    

    

    

   



    




    

    

}